/**
 * Photos route — /photos
 *
 * Composes:
 *   - PhotoUpload: drop-zone + file picker + iOS camera → upload → session start
 *   - PhotoGallery: grid of uploaded photos with session start actions
 *
 * Protected by withAuthenticator at the App level (App.tsx).
 */

import { Link } from 'react-router-dom';
import { PhotoUpload } from '../components/PhotoUpload/PhotoUpload';
import { PhotoGallery } from '../components/PhotoUpload/PhotoGallery';

export function Photos() {
  return (
    <main className="min-h-dvh bg-stone-50">
      <div className="max-w-2xl mx-auto px-4 py-8 space-y-8">
        {/* Header */}
        <header>
          <Link
            to="/"
            className="inline-flex items-center gap-1.5 text-sm text-stone-500 hover:text-stone-700 transition-colors mb-3"
          >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="w-4 h-4" aria-hidden="true">
              <path fillRule="evenodd" d="M17 10a.75.75 0 01-.75.75H5.612l4.158 3.96a.75.75 0 11-1.04 1.08l-5.5-5.25a.75.75 0 010-1.08l5.5-5.25a.75.75 0 111.04 1.08L5.612 9.25H16.25A.75.75 0 0117 10z" clipRule="evenodd" />
            </svg>
            Dashboard
          </Link>
          <h1 className="text-2xl font-serif text-stone-900">Your Photos</h1>
          <p className="text-stone-500 text-sm mt-1">
            Upload a photo to start a memory session. The AI will ask you about the people,
            place, and moment captured.
          </p>
        </header>

        {/* Upload section */}
        <section aria-label="Upload a photo">
          <div className="bg-white rounded-2xl shadow-sm border border-stone-200 p-6">
            <h2 className="text-sm font-semibold text-stone-700 mb-4 uppercase tracking-wide">
              Upload a Photo
            </h2>
            <PhotoUpload />
          </div>
        </section>

        {/* Gallery section */}
        <section aria-label="Your uploaded photos">
          <div className="bg-white rounded-2xl shadow-sm border border-stone-200 p-6">
            <h2 className="text-sm font-semibold text-stone-700 mb-4 uppercase tracking-wide">
              Your Photos
            </h2>
            <PhotoGallery />
          </div>
        </section>

        {/* HEIC note */}
        <p className="text-xs text-stone-400 text-center">
          Note: HEIC photos from iPhone are stored and will start sessions correctly.
          Gallery preview for HEIC requires browser support — full conversion available in a future update.
        </p>
      </div>
    </main>
  );
}
